import { LABELS } from '@/constants/common/message.constants'

import { type UserMeExEntity } from '../..'

/**
 * ユーザータイプ
 */
export type UserType = UserMeExEntity['type']

export const USER_TYPE = {
  /** テナントユーザー */
  OWNER: 'OWNER',
  /** パートナーユーザー */
  PARTNER: 'PARTNER'
} as const satisfies Record<UserType, UserType>

export const USER_TYPE_LABEL = {
  [USER_TYPE.OWNER]: LABELS.USER_TYPE_OWNER,
  [USER_TYPE.PARTNER]: LABELS.USER_TYPE_PARTNER
} as const satisfies Record<UserType, string>

export type UserRole = UserMeExEntity['userRole']

export const USER_ROLE = {
  // 管理者ユーザー
  ADMIN: 'ADMIN',
  // 一般ユーザー
  GENERAL: 'GENERAL'
} as const satisfies Record<UserRole, string>

export const USER_ROLE_LABEL = {
  [USER_ROLE.ADMIN]: LABELS.USER_ROLE_ADMIN,
  [USER_ROLE.GENERAL]: LABELS.USER_ROLE_GENERAL
} as const satisfies Record<UserRole, string>
